import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import styled from 'styled-components';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

import { TransactionStatusService } from '../../domain';

const StyledContainer = styled(Container)`
    font-family: Montserrat, sans-serif;
    color: rgba(41, 37, 97, 1);
    color: rgba(41, 37, 97, 1);
    background: rgb(234, 222, 208);
    padding: 40px 12%;
    text-align: left;
    border-radius: 2px;

    margin: 0 auto;
`;

const Title = styled.h1`
    font-size: 34px;
    font-weight: 700;
    font-family: Montserrat, sans-serif;
    padding: 30px 0px;
    color: #292561;
`;

const DescriptionText = styled.p`
    font-size: 20px;
    font-weight: 500;
    color: #292561;
    font-family: Montserrat, sans-serif;
    margin-top: 10px;
    margin-bottom: 0;
`;

const NextSteps = styled.h3`
    font-size: 22px;
    font-weight: 700;
    color: #292561;
    font-family: Montserrat, sans-serif;
    margin-top: 20px;
    margin-bottom: 10px;
`;

const FooterText = styled.p`
    font-size: 20px;
    font-weight: 500;
    color: #292561;
    font-family: Montserrat, sans-serif;
    margin-bottom: 10px;
    width: 80%;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
    }
`;

const Loading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
`;

export default function Stage() {
    const { id: stage } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [allowReload, setAllowReload] = useState(false);

    const _TransactionStatusService = new TransactionStatusService();

    const handleTransactionStatus = async (tranxRef, callback = () => {}) => {
        try {
            document.body.style.overflow = 'hidden';
            const res = await _TransactionStatusService.execute({ tranxRef });
            const { policyStatus } = res;

            if (['s', 'f'].includes(policyStatus)) navigate(`/stage/${policyStatus}`);
            if (!callback) return;
            callback(); // retry if it fails
        } catch (error) {
            console.error('API handleTransactionStatus Call error', error);
        }
    };

    useEffect(() => {
        if (stage) {
            if (stage === 's') {
                navigate('/success');
            } else if (stage === 'f') {
                navigate('/failed');
            } else {
                setLoading(true);
                handleTransactionStatus(stage, () =>
                    handleTransactionStatus(stage, () => {
                        setAllowReload(true);
                        handleTransactionStatus(stage, () =>
                            handleTransactionStatus(stage, () =>
                                handleTransactionStatus(stage, () => {
                                    setTimeout(() => window.location.reload(), 5000);
                                })
                            )
                        );
                    })
                );
            }
        }
    }, []);

    return (
        <>
            <Loading>
                <Spinner animation="border" variant="light" />
            </Loading>
        </>
    );
}
